import dynamic from 'next/dynamic';
import { memo, type FC } from 'react';

import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { FEATURE_FLAGS } from '@/domains/productDiscovery/Recommendation/constants';
import type { OutlineBundleProps } from '@/domains/productDiscovery/Recommendation/modules/ProductBundle/components/OutlineBundle/OutlineBundle';

import { OutlineBundlePlaceholder } from './components/OutlineBundle/OutlineBundle.placeholder';

const OutlineBundle = dynamic<OutlineBundleProps>(
  () =>
    import(
      '@/domains/productDiscovery/Recommendation/modules/ProductBundle/components/OutlineBundle/OutlineBundle'
    ).then((mod) => mod.OutlineBundle),
  {
    ssr: false,
    loading: () => <OutlineBundlePlaceholder />,
  },
);

const ProductBundleContextProvider = dynamic(
  () =>
    import(
      '@/domains/productDiscovery/Recommendation/modules/ProductBundle/context/ProductBundleContextProvider'
    ).then((mod) => mod.ProductBundleContextProvider),
  {
    ssr: true,
  },
);

export interface ProductBundleContainerProps {
  onFlashMessageEnter?: () => void;
  onFlashMessageExit?: () => void;
}

export const ProductBundleContainer: FC<ProductBundleContainerProps> = memo(
  ({ onFlashMessageEnter, onFlashMessageExit }) => {
    const [isProductBundleAbEnabled] = useBooleanFlags([
      FEATURE_FLAGS.BUNDLE_ENABLED as string,
    ]);

    if (isProductBundleAbEnabled) return null;

    return (
      <ProductBundleContextProvider>
        <OutlineBundle
          onFlashMessageEnter={onFlashMessageEnter}
          onFlashMessageExit={onFlashMessageExit}
        />
      </ProductBundleContextProvider>
    );
  },
);

ProductBundleContainer.displayName = 'ProductBundleContainer';
